import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import styles from '../styles/components/new-modal';
import ScrollLock from './ScrollLock';


const Overlay = ({
  children,
  onClick,
}) => {
  return (
    <div className={styles.overlay} onClick={onClick} data-element="overlay">
      {children}
    </div>
  );
};


const Modal = ({
  children,
}) => {
  return (
    <div className={styles.modal} data-element="modal">
      {children}
    </div>
  );
};


class NewModal extends React.Component {

  render() {
    const { isVisible, children } = this.props;
    return (
      <>
        {ReactDOM.createPortal(
          <CSSTransition
            in={isVisible}
            timeout={500}
            mountOnEnter
            unmountOnExit
            classNames="modalTransition">
            <Overlay>
              <Modal>
                {children}
              </Modal>
            </Overlay>
          </CSSTransition>,
          document.getElementById('modals-outlet'),
        )}
        {/* Body scroll lock through the shared ref-counted helper (see components/Modal) */}
        <ScrollLock active={!!isVisible} />
      </>
    );
  }

}


export default NewModal;
